module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/am498-cd66b8e7182caceac443a7d2645e7889.jpg";